import {
  findFridayOfPreviousWeeks,
  findFridayOfFollowingWeeks,
  formatDate,
} from "../../../helpers/dates";
import { formatCourse } from "../../../helpers/ihbrisbane";
import { getPaymentOptionParameters } from "../../../helpers/tools";
import { latinAmericaEuropeGenerateExtraFeesADCCD } from "./extra-fees";

function generatePaymentsOption1(data, course, startDate, coursePrice) {
  const courseName = formatCourse(course?.coursePricing?.course);

  let {
    tuition_installments_amount, // $1000
    tuition_installments_interval_weeks, // 1 Month = 4 weeks
  } = getPaymentOptionParameters(data, "option_1", "both");

  const payments = [];

  let remainingAmount = coursePrice;

  // Monthly instalments starting from one week before the course start date
  let paymentDate = findFridayOfPreviousWeeks(startDate, 1);
  payments.push({
    dueDate: formatDate(paymentDate),
    courseName,
    feeDescription: "Tuition installment",
    paymentAmount: tuition_installments_amount,
    code: "tuition_installment",
  });
  remainingAmount -= tuition_installments_amount;
  // Every month payment
  while (tuition_installments_amount <= remainingAmount) {
    paymentDate = findFridayOfFollowingWeeks(
      paymentDate,
      tuition_installments_interval_weeks
    );
    payments.push({
      dueDate: formatDate(paymentDate),
      courseName,
      feeDescription: "Tuition installment",
      paymentAmount: tuition_installments_amount,
      code: "tuition_installment",
    });
    remainingAmount -= tuition_installments_amount;
  }

  // Last month, if there is a residual payment
  if (remainingAmount !== 0) {
    payments.push({
      dueDate: formatDate(
        findFridayOfFollowingWeeks(
          paymentDate,
          tuition_installments_interval_weeks
        )
      ),
      courseName,
      feeDescription: "Tuition installment",
      paymentAmount: remainingAmount,
      code: "tuition_installment",
    });
  }

  return payments;
}

export function latinAmericaEuropeOption1ADCCD(
  data,
  paymentType,
  courses,
  specialCases
) {
  const {
    first_tuition_installment_amount, // $1000 AUS
  } = getPaymentOptionParameters(data, "option_1", "both");

  // First tuition
  let result = [
    {
      dueDate: formatDate(new Date()),
      feeDescription: "Tuition installment",
      courseName: formatCourse(courses[0]?.coursePricing?.course),
      paymentAmount: first_tuition_installment_amount,
      code: "tuition_installment",
    },
    ...latinAmericaEuropeGenerateExtraFeesADCCD(
      data,
      paymentType,
      courses,
      specialCases
    ),
  ];

  for (const [index, course] of courses.entries()) {
    let startDate = course?.startDate;
    // Remove amount of the first tuition of the first price
    let tuition_fee = course?.finalTuition;
    if (index === 0) {
      tuition_fee -= first_tuition_installment_amount;
    }
    result = [
      ...result,
      ...generatePaymentsOption1(data, course, startDate, tuition_fee),
    ];
  }

  return result;
}
